import { render, staticRenderFns } from "./Contratacoes.vue?vue&type=template&id=69ddc03b"
import script from "./Contratacoes.vue?vue&type=script&lang=js"
export * from "./Contratacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports